'use client';

import { useQuery } from '@tanstack/react-query';
import { ComponentProps } from 'react';
import { QueryApi } from '@/features/query/api';
import { formatAddress } from '@/shared/lib/formatAddress';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

const VenueAddressWrapper = ({ children, ...props }: Props) => {
    return (
        <Layout
            media={{
                ...props.media,
                initial: {
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    alignItems: 'center',
                    ...props.media?.initial,
                },
            }}
            {...props}
        >
            {children}
        </Layout>
    );
};

const VenueAddressIcon = (props: Props) => {
    return (
        <Layout
            media={{ ...props.media, initial: { width: 24, height: 24, ...props.media?.initial } }}
            {...props}
        >
            <Icon name="map-pin" />
        </Layout>
    );
};

const VenueAddressText = () => {
    const venueQuery = useQuery(QueryApi.Venue.queries.Venue);

    return (
        <Layout element="a" href={`geo:${venueQuery.data?.address?.lon},${venueQuery.data?.address?.lat}`}>
            {formatAddress(venueQuery.data?.address)}
        </Layout>
    );
};

export { VenueAddressWrapper as Wrapper, VenueAddressIcon as Icon, VenueAddressText as Text };
